import { PageContainer } from "@/components/container/page-container";
import { PageTitleComponent } from "@/components/page-title";
import { PrivacyAgreementContent } from "@/pages/welcome-screen/privacy-content";

export default function PrivacyPage() {
  return (
    <PageContainer
      className="app-bar-bottom-padding no-scrollbar h-full w-full overflow-y-auto"
      showLogo={true}
    >
      <div className="mt-4 flex h-full w-full flex-col items-start gap-8">
        <PageTitleComponent title="Privacy Policy" />
        <PrivacyAgreementContent />
      </div>
    </PageContainer>
  );
}
